import React, { memo } from 'react';
import { Button, CONTAINED_VARIANT, NO_ICON, SIZE_44 } from '@yme/atoms/button';
import { ANCHOR_LINK_TEST_ID, AnchorStyled } from '@yme/molecules/buttons';
import { isExternalLink } from '@yme/utils/common';
import { BLANK, SELF } from '@yme/utils/constants';
function ButtonAnchorComponent(props) {
    const { isRightToLeft, buttonLabel, buttonTitle = '', buttonWidth, size = SIZE_44, buttonLink, buttonVariant = CONTAINED_VARIANT, hasIconButton = NO_ICON, iconComponent, iconRotate, className, isDarkMode, isExternal, onClick, } = props;
    if (buttonLabel && buttonLink) {
        const isLinkExternal = isExternal || isExternalLink(buttonLink);
        return (React.createElement(AnchorStyled, { href: buttonLink, target: isLinkExternal ? BLANK : SELF, className: className, onClick: onClick, "data-testid": ANCHOR_LINK_TEST_ID },
            React.createElement(Button, { as: "span", isDarkMode: isDarkMode, buttonVariant: buttonVariant, hasIconButton: hasIconButton, iconComponent: iconComponent, iconRotate: iconRotate, size: size, label: buttonLabel, title: buttonTitle, isRightToLeft: isRightToLeft, width: buttonWidth })));
    }
    return null;
}
export const ButtonAnchor = memo(ButtonAnchorComponent);
ButtonAnchor.displayName = 'ButtonAnchor';
